export class Immutable {
    #original;
    #modified = undefined;
    constructor(value) {
        this.#original = value;
    }
    value() {
        return this.#modified ?? this.#original;
    }
    update(updater) {
        this.#modified ??= structuredClone(this.#original);
        updater(this.#modified);
    }
}
